// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2hPn6","row":"styles_row__2opcU"};